export { ArticleContaminantFacts } from './ArticleContaminantFacts';
